export const lostReasonFeatureKey = 'lostReason';

export type LostReasonModel = {
  id: number;
  name: string;
  active: boolean;
  needSummary: boolean;
};
